import { FC } from 'react';
import { ListItem, Drawer, List, ListItemText } from '@mui/material';
import { Typography } from '@mui/material';
import { Layer, Source } from 'react-map-gl'
import { Slider } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { t } from '../utils/strings';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Stack } from '@mui/material';

const RastersWidget: FC<any> = ({
  rastersWidgetOpen, rasterData, handleRastersWidgetOpen,
  renderedRasters, setRenderedRasters, rastersHidden, lang
}) => {

  return <>{<Drawer

    variant='persistent'
    sx={{ zIndex: 3 }}
    PaperProps={{ style: { height: 'calc(100% - 80px)', top: '80px', zIndex: 3, background: 'whitesmoke' } }}
    anchor="right"
    open={rastersWidgetOpen}
  >
    <div style={{ width: '35vw', textAlign: 'center', paddingTop: '10px', paddingRight: '40px' }}>
      <Typography variant="h6">{t('historicalMapsAndImagery', lang)}</Typography>
      <List>
        {
          rasterData.map((item, i) =>
            <ListItem
              key={i}
              sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', py: 0.1 }}
            >

              <ListItemText
                primary={
                  item.title.includes(': ') ? (
                    <span style={{ display: 'inline-flex' }}>
                      <span style={{ minWidth: '3.5em', flexShrink: 0 }}>{item.title.split(': ')[0]}:&nbsp;</span>
                      <span>{item.title.substring(item.title.indexOf(': ') + 2)}</span>
                    </span>
                  ) : item.title
                }
                sx={{ maxWidth: '25vw', '& .MuiListItemText-primary': { fontSize: '0.8rem' } }} />
              <Stack spacing={1} direction="row" sx={{ ml: 1 }} alignItems="center">
                <VisibilityOffIcon sx={{ fontSize: 18 }} />
                <Slider
                  min={0}
                  max={10}
                  defaultValue={0}
                  value={(renderedRasters?.find(rast => (rast.source === item.source))?.opacity || 0) * 10}
                  onChange={(e, _val: number) => {
                    setRenderedRasters(rasters =>
                      rasters.map(rast => (rast.source === item.source ? ({ ...rast, opacity: _val / 10 }) : rast))
                    )
                  }}
                  sx={{ width: '2.5vw' }}
                  size="small"
                />
                <VisibilityIcon sx={{ fontSize: 18 }} />
              </Stack>
            </ListItem>
          )
        }
      </List>
    </div>

  </Drawer>}
    {rasterData.map(tile => {
      const opacity = renderedRasters.find(item => tile.source === item.source)?.opacity ?? 0;
      if (opacity <= 0) return null;
      return (
        <Source
          {...(tile.tiles
            ? { tiles: tile.tiles, tileSize: 256, scheme: 'xyz' as const }
            : { url: 'mapbox://' + tile.source }
          )}
          type='raster'
          id={tile.source}
          key={tile.source}
        >
          <Layer
            id={tile.source}
            type='raster'
            beforeId='pointLayer'
            paint={{ 'raster-opacity': rastersHidden ? 0 : opacity }}
          />
        </Source>
      );
    })}
  </>
}
export default RastersWidget